import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { Spinner } from "modules/common/components";
import { livemonitorSelector } from "store/selector";
import HRNumbers from "human-readable-numbers";
import { connect } from "react-redux";
// import {
//   SummaryItem,
//   SummaryTitle,
//   SummaryCount,
//   LoaderWrapper,
//   SummaryIcon
// } from '../styles';
import { colors } from "modules/common/styles";
import {
  InsightTitle,
  LoaderWrapper,
  StatusCount,
  StatusItem,
  StatusTitle,
  TotalCallCount,
  TotalCallItem,
  TotalCallTitle,
} from "../styles/main";
import { injectGlobal } from "styled-components";

const propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

injectGlobal`

  .col-total-call-item{
    &:last-child{
      .total-call-item{
        padding: 0;
      }
    }
  }

  .total-call-item {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
  }


`;

class RowWrapper extends Component {
  render() {
    return (
      <Row
        style={{
          padding: "10px",
          background: "#f9f9f9",
          borderRadius: "10px",
          margin: "0px 18px",
        }}
      >
        {this.props.children}
      </Row>
    );
  }
}

export class LiveMonitorTileTheme extends Component {
  renderTileRow(image, title, number) {
    return (
      <Col sm={12} className="col-total-call-item">
        <TotalCallItem className="total-call-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <img
              style={{ marginRight: "10px" }}
              src={image}
              className="loadImg"
            />
            <TotalCallTitle className="livetile-title">{title}</TotalCallTitle>
          </span>
          <TotalCallCount className="totalcallcount">
            {HRNumbers.toHumanString(number || 0)}{" "}
          </TotalCallCount>
        </TotalCallItem>
      </Col>
    );
  }

  renderTotalCalls(item) {
    return this.renderTileRow(item.icon, item.title, item.count);
  }

  render() {
    const { __ } = this.context;
    let { data, loading, liveData, forAgentDashboard } = this.props;
    if (loading) {
      return (
        <LoaderWrapper>
          <Spinner objective />
        </LoaderWrapper>
      );
    }
    if (forAgentDashboard) {
      return (
        <RowWrapper>
          {data.map((detail) => this.renderTotalCalls(detail))}
        </RowWrapper>
      );
    }

    return (
      <RowWrapper>
        {this.renderTileRow(
          "/images/icons/ic_total_call.svg",
          "Total Call",
          liveData.totalCall
        )}
        {this.renderTileRow(
          "/images/icons/ic_inbound_call.svg",
          "Inbound Call",
          liveData.TotalInboundCall
        )}
        {this.renderTileRow(
          "/images/icons/ic_outgoing_call.svg",
          "Outbound Call",
          liveData.TotalOutBoundCall
        )}
      </RowWrapper>
    );
  }
}

const stateToProps = (state) => ({
  liveData: livemonitorSelector.getLiveDynamic(state, { key: "liveData" }),
  // state: livemonitorSelector.getLiveDynamic(state, { key: 'state' }),
});

const dispatchToProps = (dispatch) => ({});
export default connect(stateToProps, dispatchToProps)(LiveMonitorTileTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveMonitorTileTheme.js